export default __webpack_public_path__ + "static/OpenSans-ExtraBold-88c519b23b7fee683e1c2aadabd82d94.woff2";